import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
  buttonStyle: {
    border: "none",
    background: "transparent",
    color: "grey",
    "&:hover": {
      color: "#DF767D",
      textDecoration: "underline",
    },
    "&:disabled": {
      opacity: "0.5",
      cursor: "not-allowed",
      textDecoration: "none",
      color: "grey",
    },
  },
}));

export default function ClearButton({ disable, onClick, fullWidth }) {
  const classes = useStyles();

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disable}
      className={classes.buttonStyle}
      style={{ width: fullWidth ? "100%" : "auto" }}
    >
      Limpar filtros
    </button>
  );
}
